import * as React from 'react'
import type { ISocialMedia } from './social-media.types';
import { Button, ButtonSize } from '@components/molecules';
import { cn } from '@utils';

interface Props {
	data: ISocialMedia[];
}

interface Props {
	data: ISocialMedia[];
	className?: string;
}

const SocialMediaLinks = React.forwardRef<HTMLUListElement, Props>(({ data, className }, ref) => {
	return (
		<ul className={cn('flex gap-4', className)} data-aid="social-media-links" ref={ref}>
			{data.map(({ url, icon }, index) => (
				<li key={`social-media-links-${index}`}>
					<Button asChild={Boolean(url)} disabled={!url} variant="icon" size={ButtonSize.XS} className="flex">
						<a href={url} target="_blank" rel="noreferrer" className={!url ? 'pointer-events-none' : ''}>
							{icon}
						</a>
					</Button>
				</li>
			))}
		</ul>
	);
});

SocialMediaLinks.displayName = 'SocialMediaLinks';

export { SocialMediaLinks };
